module.exports = __webpack_public_path__ + "static/media/piper-bg-yellow.b2507732.svg";